module.exports = __webpack_public_path__ + "a9a970f99b48c061a9010dbe8df429de.pdf";